import React from "react";
import {Link, useLocation} from "react-router-dom";
import styled from "styled-components";

const GuideNavContainer = styled.nav`
    background: white;
    padding: 1rem;
    margin-bottom: 2rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const NavList = styled.ul`
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 1rem;
`;

const NavItem = styled.li<{ active: string }>`
    a {
        text-decoration: none;
        color: ${props => props.active === 'true' ? '#1890ff' : '#666'};
        font-weight: ${props => props.active === 'true' ? 'bold' : 'normal'};
        padding: 0.5rem 1rem;
        border-radius: 4px;
        transition: all 0.2s ease;

        &:hover {
            background-color: #f5f5f5;
            color: #1890ff;
        }
    }
`;

const GuideNav = () => {
    const location = useLocation();

    return (
        <GuideNavContainer>
            <NavList>
                <NavItem active={location.pathname === '/guide' ? 'true' : 'false'}>
                    <Link to="/guide">Home</Link>
                </NavItem>
                <NavItem active={location.pathname === '/guide/availability' ? 'true' : 'false'}>
                    <Link to="/guide/availability">Availability</Link>
                </NavItem>
                <NavItem active={location.pathname === '/guide/finance' ? 'true' : 'false'}>
                    <Link to="/guide/finance">Finance</Link>
                </NavItem>
                <NavItem active={location.pathname === '/guide/reviews' ? 'true' : 'false'}>
                    <Link to="/guide/reviews">Reviews</Link>
                </NavItem>
                <NavItem active={location.pathname === '/guide/profile' ? 'true' : 'false'}>
                    <Link to="/guide/profile">Profile</Link>
                </NavItem>
            </NavList>
        </GuideNavContainer>
    );
};

export default GuideNav;
